<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      School
    </button>
    <a-drawer
      title="Add a new school"
      :width="
        this.settings['isMobileView']
          ? 480
          : this.settings['isTabletView']
          ? 720
          : 1080
      "
      @close="handleCancel"
      :visible="visible"
      :wrapStyle="{
        height: 'calc(100% - 10px)',
        overflow: 'auto',
        paddingBottom: '10px',
      }"
      placement="right"
    >
      <a-spin :spinning="loading">
        <a-form class="mb-4" :form="form">
          <p>Basic Details</p>
          <div class="row">
            <div class="col-md-8">
              <a-form-item label="School name">
                <a-input
                  placeholder="School name"
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input school name!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Select Board">
                <a-select
                  v-decorator="[
                    'board_id',
                    {
                      rules: [
                        { required: true, message: 'Please select a board!!' },
                      ],
                    },
                  ]"
                  placeholder="Select board"
                >
                  <a-select-option
                    v-for="board in boards"
                    :value="board.id"
                    :key="board.id"
                  >
                    {{ board.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Institute type">
                <a-select
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select an institute type!!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Institute type"
                >
                  <a-select-option
                    v-for="institutetype in instituteTypes"
                    :value="institutetype.value"
                    :key="institutetype.value"
                  >
                    {{ institutetype.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Owner type">
                <a-select
                  v-decorator="[
                    'owner_type',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select an owner type!!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Owner type"
                >
                  <a-select-option
                    v-for="ownertype in ownerTypes"
                    :value="ownertype.value"
                    :key="ownertype.value"
                  >
                    {{ ownertype.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Registration No">
                <a-input
                  placeholder="Registration No"
                  v-decorator="[
                    'registration_no',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input Registration No!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="School website">
                <a-input
                  placeholder="School website"
                  v-decorator="[
                    'school_website',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input a valid url!',
                          pattern: new RegExp(
                            `^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$`
                          ),
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Subdomain">
                <a-input
                  placeholder="Subdomain"
                  v-decorator="[
                    'subdomain',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please enter a valid subdomain!',
                          pattern: new RegExp(`^[_A-z]*((-|\s)*[_A-z])*$`),
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Established on">
                <a-date-picker
                  v-decorator="[
                    'established_on',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input establised date!',
                        },
                      ],
                    },
                  ]"
                  :disabled-date="disabledDate"
                  :format="dateFormat"
                />
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">School Address</p>

          <div class="row">
            <div class="col-md-8">
              <a-form-item label="Address">
                <a-input
                  placeholder="Street address"
                  v-decorator="[
                    'contact[address]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input school address!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="City">
                <a-input
                  placeholder="City"
                  v-decorator="[
                    'contact[city]',
                    {
                      rules: [
                        { required: true, message: 'Please input city!' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="District">
                <a-input
                  placeholder="District"
                  v-decorator="[
                    'contact[district]',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input a district!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Landmark">
                <a-input
                  placeholder="Landmark"
                  v-decorator="[
                    'contact[landmark]',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input a landmark!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Pincode">
                <a-input
                  placeholder="Pincode"
                  v-decorator="[
                    'contact[pincode]',
                    {
                      rules: [
                        { required: true, message: 'Please input a pincode!' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="State">
                <a-input
                  placeholder="State"
                  v-decorator="[
                    'contact[state]',
                    {
                      rules: [
                        { required: true, message: 'Please input a state!' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Country">
                <a-input
                  placeholder="Country"
                  v-decorator="[
                    'contact[country]',
                    {
                      rules: [
                        { required: true, message: 'Please input a country!' },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4 d-none">
              <a-form-item label="Is Primary Contact?">
                <a-checkbox
                  v-decorator="[
                    'contact[is_primary]',
                    {
                      valuePropName: 'checked',
                      initialValue: true,
                    },
                  ]"
                >
                  Yes
                </a-checkbox>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">School Contact</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Phone">
                <a-input
                  placeholder="Phone"
                  v-decorator="[
                    'contact[phone]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input a valid phone!',
                          pattern: new RegExp(`^[0-9]{7,14}$`),
                        },
                      ],
                    },
                  ]"
                  width="100%"
                >
                  <a-select
                    slot="addonBefore"
                    v-decorator="[
                      'contact[country_code]',
                      { initialValue: '91' },
                    ]"
                    style="width: 70px"
                  >
                    <a-select-option
                      v-for="countryCode in countryCodes"
                      :value="countryCode.value"
                      :key="countryCode.value"
                    >
                      <span class="text-bold">{{ countryCode.name }}</span>
                    </a-select-option>
                  </a-select>
                </a-input>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Alt. Phone">
                <a-input
                  placeholder="Alt. Phone"
                  v-decorator="[
                    'contact[alt_phone]',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input an valid alt phone!',
                          pattern: new RegExp(`^[0-9]{7,14}$`),
                        },
                      ],
                    },
                  ]"
                  width="100%"
                >
                  <a-select
                    slot="addonBefore"
                    v-decorator="[
                      'contact[alt_country_code]',
                      { initialValue: '91' },
                    ]"
                    style="width: 70px"
                  >
                    <a-select-option
                      v-for="countryCode in countryCodes"
                      :value="countryCode.value"
                      :key="countryCode.value"
                    >
                      <span class="text-bold">{{ countryCode.name }}</span>
                    </a-select-option>
                  </a-select>
                </a-input>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Email">
                <a-input
                  placeholder="Email"
                  v-decorator="[
                    'contact[email]',
                    {
                      rules: [
                        {
                          type: 'email',
                          message: 'The input is not valid email!',
                        },
                        {
                          required: true,
                          message: 'Please input an email!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">School GST Details</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="GST Number">
                <a-input
                  placeholder="GST Number"
                  v-decorator="[
                    'gst_no',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input school GST number!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="GST Name">
                <a-input
                  placeholder="GST Name"
                  v-decorator="[
                    'gst_name',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input a gst number!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-8">
              <a-form-item label="GST Address">
                <a-input
                  placeholder="GST Address"
                  v-decorator="[
                    'gst_address',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input GST Address!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Currency Details</p>

          <div class="row">
            <div class="col-md-2 col-6">
              <a-form-item label="Currency code">
                <a-select
                  v-decorator="[
                    'currency_code',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a currency code!!',
                        },
                      ],
                      initialValue: 'INR',
                    },
                  ]"
                >
                  <a-select-option
                    v-for="currencyCode in currencyCodes"
                    :value="currencyCode.value"
                    :key="currencyCode.value"
                  >
                    {{ currencyCode.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-2 col-6">
              <a-form-item label="Currency symbol">
                <a-select
                  v-decorator="[
                    'currency_symbol',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a currency symbol!!',
                        },
                      ],
                      initialValue: '₹',
                    },
                  ]"
                >
                  <a-select-option
                    v-for="currencySymbol in currencySymbols"
                    :value="currencySymbol.value"
                    :key="currencySymbol.value"
                  >
                    <span class="text-bold">{{ currencySymbol.name }}</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Account Details</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Select a plan">
                <a-radio-group
                  v-decorator="[
                    'plan_school[plan_id]',
                    {
                      rules: [
                        { required: true, message: 'Please select a plan!' },
                      ],
                    },
                  ]"
                  @change="handlePlanChange"
                >
                  <a-radio
                    v-for="plan in plans"
                    :value="plan.id"
                    :key="plan.id"
                    class="mr-5"
                  >
                    <span class="text-bold">{{ plan.name }}</span>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Price">
                <a-input-number
                  v-decorator="[
                    'plan_school[price]',
                    {
                      rules: [
                        { required: true, message: 'Please input a price' },
                      ],
                    },
                  ]"
                  :min="0"
                  :width="200"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Payment Frequency">
                <a-select
                  v-decorator="[
                    'plan_school[payment_frequency]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a payment frequency',
                        },
                      ],
                      initialValue: 2,
                    },
                  ]"
                >
                  <a-select-option
                    v-for="paymentFrequency in paymentFrequencies"
                    :value="paymentFrequency.value"
                    :key="paymentFrequency.value"
                  >
                    {{ paymentFrequency.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Start Date">
                <a-date-picker
                  v-decorator="[
                    'plan_school[start_date]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input a start date',
                        },
                      ],
                      initialValue: moment(),
                    },
                  ]"
                  :format="dateFormat"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="End Date">
                <a-date-picker
                  v-decorator="[
                    'plan_school[end_date]',
                    {
                      rules: [
                        { required: true, message: 'Please input a end date' },
                      ],
                      initialValue: moment().add(1, 'Y'),
                    },
                  ]"
                  :format="dateFormat"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="School Status">
                <a-radio-group
                  v-decorator="[
                    'status',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a school status',
                        },
                      ],
                      initialValue: 1,
                    },
                  ]"
                >
                  <a-radio :value="1">Active</a-radio>
                  <a-radio :value="0">Inactive</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Academic Settings</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Auto generate">
                <a-checkbox
                  v-decorator="[
                    'auto_student_id',
                    {
                      valuePropName: 'checked',
                      initialValue: true,
                    },
                  ]"
                >
                  Student ID
                </a-checkbox>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Id suffix">
                <a-input
                  placeholder="NEO"
                  v-decorator="[
                    'id_suffix',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input an ID suffix',
                        },
                        {
                          max: 10,
                          message: 'Should not be more than 10 characters',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Admission no. starts from">
                <a-input-number
                  placeholder="1000"
                  v-decorator="[
                    'start_admission_no',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input admission no starts from!',
                        },
                      ],
                      initialValue: 0,
                    },
                  ]"
                  :min="0"
                  :width="200"
                />
              </a-form-item>
            </div>

            <!-- Staff Id -->
            <div class="col-md-4">
              <a-form-item label=" " :colon="false">
                <a-checkbox
                  v-decorator="[
                    'auto_staff_id',
                    {
                      valuePropName: 'checked',
                      initialValue: true,
                    },
                  ]"
                >
                  Staff ID
                </a-checkbox>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Staff Id suffix">
                <a-input
                  placeholder="NEO"
                  v-decorator="[
                    'staff_id_suffix',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input an ID suffix',
                        },
                        {
                          max: 10,
                          message: 'Should not be more than 10 characters',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Start System Staff Id">
                <a-input
                  placeholder="100"
                  v-decorator="[
                    'start_system_staff_id',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input an ID suffix',
                        },
                        {
                          max: 10,
                          message: 'Should not be more than 10 characters',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Staff Id no. starts from">
                <a-input-number
                  placeholder="1000"
                  v-decorator="[
                    'start_staff_id_no',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input staff id no starts from!',
                        },
                      ],
                      initialValue: 0,
                    },
                  ]"
                  :min="0"
                  :width="200"
                />
              </a-form-item>
            </div>
          </div>

          <a-divider />

          <p class="pt-3">Default School Session</p>

          <div class="row">
            <!-- Initial school Session -->
            <div class="col-md-4">
              <a-form-item label="Session Start Date">
                <a-date-picker
                  v-decorator="[
                    'school_session[start_date]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input a start date',
                        },
                      ],
                      initialValue: moment(),
                    },
                  ]"
                  :format="dateFormat"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Session End Date">
                <a-date-picker
                  v-decorator="[
                    'school_session[end_date]',
                    {
                      rules: [
                        { required: true, message: 'Please input an end date' },
                      ],
                      initialValue: moment().add(1, 'Y'),
                    },
                  ]"
                  :format="dateFormat"
                />
              </a-form-item>
            </div>
          </div>

          <p class="pt-3">School Working Hour</p>
          <!-- <working-hour-element></working-hour-element> -->

          <table>
            <tbody>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[1][day]']" value="MONDAY">Monday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[1][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[1][end_time]']" use24-hours />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['weekly_working_hour[same_daily_timing]']" value="1" @change="handleSameTime">Same for all</a-checkbox>
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[2][day]']" default-value="TUESDAY">Tuesday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[2][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[2][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[3][day]']" default-value="WEDNESDAY">Wednesday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[3][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[3][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[4][day]']" default-value="THURSDAY">Thursday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[4][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[4][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[5][day]']" default-value="FIRDAY">Friday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[5][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[5][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[6][day]']" default-value="SATURDAY">Saturday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[6][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[6][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hour[0][day]']" default-value="SUNDAY">Sunday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[0][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[0][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- <div class="row">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[2][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[2][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hours[3][day]']" default-value="WEDNESDAY">Wednesday</a-checkbox>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[3][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[3][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hours[4][day]']" default-value="THURSDAY">Thursday</a-checkbox>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[4][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[4][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hours[5][day]']" default-value="FRIDAY">Friday</a-checkbox>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[5][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[5][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hours[6][day]']" default-value="SATURDAY">Saturday</a-checkbox>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[6][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[6][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-checkbox @change="handleDayCheck" v-decorator="['daily_working_hours[0][day]']" default-value="SUNDAY">Sunday</a-checkbox>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[0][start_time]']" :default-value="moment('09:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item> -
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-time-picker v-decorator="['daily_working_hours[0][end_time]']" :default-value="moment('17:00:00', 'HH:mm:ss')" use24-hours />
            </a-form-item>
          </div>

          <a-divider /> -->

          <p class="pt-3">Available facilities</p>

          <div class="row">
            <div class="col">
              <a-form-item>
                <a-checkbox
                  v-decorator="[
                    'hostel',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                >
                  Hostel
                </a-checkbox>
                <a-checkbox
                  v-decorator="[
                    'transport',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                >
                  Transport
                </a-checkbox>
                <a-checkbox
                  v-decorator="[
                    'library',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                >
                  Library
                </a-checkbox>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Skoolsync Communication</p>

          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Is skoolsync communication enabled?">
                <a-checkbox
                  v-decorator="[
                    'ssc',
                    {
                      valuePropName: 'checked',
                      initialValue: false,
                    },
                  ]"
                >
                  Yes
                </a-checkbox>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Theme Settings</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Font">
                <a-select
                  v-decorator="[
                    'font',
                    {
                      rules: [
                        { required: true, message: 'Please select a font' },
                      ],
                      initialValue: 'Source Sans Pro',
                    },
                  ]"
                >
                  <a-select-option
                    v-for="themeFont in themeFonts"
                    :value="themeFont.value"
                    :key="themeFont.value"
                  >
                    <span
                      class="text-bold"
                      :style="`font-family:${themeFont.value}`"
                    >
                      {{ themeFont.name }}
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Color">
                <a-select
                  v-decorator="[
                    'color',
                    {
                      rules: [
                        { required: true, message: 'Please select a color' },
                      ],
                      initialValue: '#1b55e3',
                    },
                  ]"
                >
                  <a-select-option
                    v-for="themeColor in themeColors"
                    :value="themeColor.value"
                    :key="themeColor.value"
                  >
                    <span class="text-bold">
                      {{ themeColor.name }}
                      <span
                        :style="`background-color:${themeColor.value};`"
                        class="neo-color-options"
                      ></span>
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3 mb-1">Upload Documents</p>
          <p class="font-italic text-warning">
            Logo should be JPG format and less than 2MB in size
          </p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Logo">
                <a-upload
                  v-decorator="[
                    'logo',
                    {
                      rules: [
                        { required: false, message: 'Please select a logo' },
                      ],
                    },
                  ]"
                  :fileList="fileList"
                  :multiple="false"
                  :remove="handleRemove"
                  :beforeUpload="beforeUpload"
                  :disabled="uploadDisabled"
                >
                  <a-button v-if="!uploadDisabled">
                    <a-icon type="upload" /> Select File
                  </a-button>
                </a-upload>
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <p class="pt-3">Admin User Details</p>

          <div class="row">
            <div class="col-md-4">
              <a-form-item label="First name">
                <a-input
                  placeholder="First name"
                  v-decorator="[
                    'user[first_name]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input user first name!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Last name">
                <a-input
                  placeholder="Last name"
                  v-decorator="[
                    'user[last_name]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input user last name!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Phone">
                <a-input
                  placeholder="Phone"
                  v-decorator="[
                    'user[phone]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input a valid phone!',
                          pattern: new RegExp(`^[0-9]{7,14}$`),
                        },
                      ],
                    },
                  ]"
                  width="100%"
                >
                  <a-select
                    slot="addonBefore"
                    v-decorator="['user[country_code]', { initialValue: '91' }]"
                    style="width: 70px"
                  >
                    <a-select-option
                      v-for="countryCode in countryCodes"
                      :value="countryCode.value"
                      :key="countryCode.value"
                    >
                      <span class="text-bold">{{ countryCode.name }}</span>
                    </a-select-option>
                  </a-select>
                </a-input>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Email">
                <a-input
                  placeholder="Email"
                  v-decorator="[
                    'user[email]',
                    {
                      rules: [
                        {
                          type: 'email',
                          message: 'The input is not valid email!',
                        },
                        {
                          required: true,
                          message: 'Please input an email!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Password">
                <a-input
                  v-decorator="[
                    'user[password]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input a password!',
                        },
                        {
                          validator: validateToNextPassword,
                        },
                      ],
                    },
                  ]"
                  type="password"
                />
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Confirm Password">
                <a-input
                  v-decorator="[
                    'user[confirm_password]',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please confirm user password!',
                        },
                        {
                          validator: compareToFirstPassword,
                        },
                      ],
                    },
                  ]"
                  type="password"
                  @blur="handleConfirmBlur"
                />
              </a-form-item>
            </div>
          </div>

          <a-divider />
          <div class="row justify-content-between py-3">
            <div class="col-md-4">
              <a-button key="clear" class="btn btn-light" @click="handleClear"
                >Clear Form</a-button
              >
            </div>
            <div class="col-md-4 text-md-right">
              <a-button key="back" @click="handleCancel" class="mr-3"
                >Cancel</a-button
              >
              <a-button
                key="submit"
                type="primary"
                :loading="loading"
                @click="handleSubmit"
                >Add School</a-button
              >
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-drawer>
  </div>
</template>

<style scoped>
.ant-drawer-close-x {
  margin-right: 0.7rem;
}
</style>

<script>
/* eslint-disable camelcase */
import { mapState } from 'vuex'
import moment from 'moment'
import {
  instituteTypes,
  ownerTypes,
  currencyCodes,
  currencySymbols,
  themeFonts,
  themeColors,
  paymentFrequencies,
} from '../data'
import { countryCodes } from '@/services/globaldata'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function (value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    if (typeof value === 'object' && value._isAMomentObject === true) {
      return moment(value).format('YYYY-MM-DD')
    }
    return value
  },
}

export default {
  name: 'AddSchool',
  // components: { workingHourElement },
  mounted: function () {
    this.form = this.$form.createForm(this)
    this.$http
      .get('/api/board')
      .then(({ data }) => {
        this.boards = data.data
      })
      .catch((error) => {
        console.log(error)
      })

    this.$http
      .get('/api/plan')
      .then(({ data }) => {
        this.plans = data.data
      })
      .catch((error) => {
        console.log(error)
      })
  },
  data: function () {
    return {
      form: '',
      confirmDirty: false,
      loading: false,
      uploadDisabled: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      boards: [],
      plans: [],
      fileList: [],
      instituteTypes,
      ownerTypes,
      currencyCodes,
      currencySymbols,
      countryCodes,
      paymentFrequencies,
      themeFonts,
      themeColors,
      workinghours: [
        { selected: false, value: 'MONDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'TUESDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'WEDNESDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'THURSDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'FRIDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'SATURDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
        { selected: false, value: 'SUNDAY', stime: moment('09:00:00', 'HH:mm:ss'), etime: moment('17:00:00', 'HH:mm:ss'), enabled: false },
      ],
    }
  },
  computed: mapState(['settings']),
  methods: {
    moment,
    showModal() {
      this.visible = true
    },
    handleDayCheck: function(e) {
      console.log(e.target)
      // this.workinghours = this.workinghours.map((d) => {
      //   if (e.target.value === d.value) {
      //     console.log('selected', d)
      //     return Object.assign(d, { selected: e.target.checked, enabled: e.target.checked })
      //   }else {
      //     return d
      //   }
      // })
      // console.log('daycheck working hours', this.workinghours)
    },
    handleSameTime: function(e) {
      console.log('same time selected', e)
      console.log('pre state working hours', this.workinghours)
      let t = this.workinghours[0]
      if (e.target.checked) {
        this.workinghours.map((d, index) => {
          if (index === 0) {
            return d
          } else {
            return Object.assign(d, { enabled: false, stime: t.stime, etime: t.etime })
          }
        })
      } else {
        // uncheck
        console.log('before unchecked', this.workinghours)

        this.workinghours = this.workinghours.map((d, index) => {
          if (index !== 0) {
            if (d.selected) {
              return Object.assign(d, { enabled: true })
            }
            return Object.assign(d, { enabled: false })
          } else {
            return d
          }
        })
        console.log('after unchecking', this.workinghours)
      }
    },
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      if (!isJPG) {
        this.$message.error('You can only upload JPG file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('user[password]')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Not same with the password!')
      } else {
        callback()
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['user[confirm_password]'], { force: true })
      }
      callback()
    },
    handlePlanChange(e) {
      const form = this.form
      const plan = this.plans.filter((plan) => {
        return plan.id === e.target.value
      })
      form.setFieldsValue({ 'plan_school[price]': plan[0].price })
    },
    processFalseInputData: function(_data, _weekdata) {
      /* eslint-disable camelcase */
      let validays = 0
      let weekwh = 0
      let w_st, w_et
      let samehr = _weekdata.same_daily_timing !== undefined
      let monday_stime = _data[1].start_time; let monday_etime = _data[1].end_time
      if (monday_stime === undefined) {
        throw Error("Timing for monday can't be null.")
      }

      let dailydata = _data.map(function(e, index) {
        if (e.day !== undefined) {
          validays += 1
          weekwh += moment.duration(moment(e.end_time).diff((moment(e.start_time)))).asHours()
        }
        switch (index) {
          case 0: {
            return { day: 'SUNDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
          case 1: {
            w_st = e.day === undefined ? undefined : moment(e.start_time).format('HH:mm:ss')
            w_et = e.day === undefined ? undefined : moment(e.end_time).format('HH:mm:ss')
            return { day: 'MONDAY', start_time: e.day === undefined ? undefined : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : moment(e.end_time).format('HH:mm:ss') }
          }
          case 2: {
            return { day: 'TUESDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
          case 3: {
            return { day: 'WEDNESDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
          case 4: {
            return { day: 'THURSDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
          case 5: {
            return { day: 'FRIDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
          case 6: {
            return { day: 'SATURDAY', start_time: e.day === undefined ? undefined : samehr ? moment(monday_stime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: e.day === undefined ? undefined : samehr ? moment(monday_etime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
          }
        }
      })

      return { daily: dailydata, weekly: { working_days: validays, working_hours: _weekdata.same_daily_timing === undefined ? weekwh : weekwh * validays, same_daily_timing: _weekdata.same_daily_timing === undefined ? 0 : 1, start_time: w_st, end_time: w_et } }
    },
    processInputData: function() {

    },
    handleSubmit(e) {
      this.loading = true

      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // console.log(values.logo)
          console.log('VALUES', values)
          console.log('TEST VALLUES', values.daily_working_hour)
          try {
            let mwh = this.processFalseInputData(values.daily_working_hour, values.weekly_working_hour)
            values.daily_working_hour = mwh.daily
            values.weekly_working_hour = mwh.weekly
          } catch (err) {
            console.log('error', err)
          }

          console.log('after processing', values)
          // return
          this.$confirm({
            title: `Are you sure you want to add school: ${values.name}?`,
            content: `Click on the OK button to add the new school!`,
            onOk: () => {
              if (!values.alt_phone) {
                values.alt_country_code = undefined
              }

              values.user.confirm_password = undefined

              let logoFile = null
              if (values.logo) {
                logoFile = values.logo.file
                values.logo = undefined
              }

              let formData = window.jsonToFormData(values, options)

              if (logoFile) {
                formData.append('logo', logoFile)
              }

              this.$http
                .post('/api/school', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'School successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.loading = false
    },
    handleClear(e) {
      this.form.resetFields()
    },
  },
}
</script>
<style lang="scss">
.neo-color-options {
  width: 20px;
  height: 20px;
  float: right;
}
.ant-select-selection-selected-value {
  .neo-color-options {
    margin-left: 1rem;
    margin-top: 0.3rem;
  }
}
</style>
